import { Box, Stack } from "@mui/material";
import dayjs from "dayjs";
import React from "react";

import { MONTH_TO_DATE, USAGE_MAPPINGS } from "config/copies/usage";
import { useMeteringInfo } from "hooks/metering/useMeteringInfo";
import { TextFieldInput } from "new-components/textFieldInput/TextFieldInput";
import { Typography } from "new-components/typography/Typography";
import { AccountSectionTitle } from "pages/account/AccountPage";
import { months } from "utils/meteringUtils";

import { ActivityByDetectorTable } from "./ActivityByDetectorTable";
import { MeteringBarChart } from "./MeteringBarChart";

// Dummy data for testing

export interface MeteringByAccountData {
  active_detectors: number;
  interval_start: string;
  escalations: number;
  userLabelersAnswers: number;
  image_queries: number;
  graphImageQueries: number;
}

export interface MeteringByDetectorData {
  detector_name: string;
  detector_id: string;
  escalations: number;
  image_queries: number;
  interval_start: string;
}

export function MeteringInfo() {
  const {
    accountMetricsError,
    handleTimePeriodChange,
    loadingAccountMetrics,
    detectorsMetrics,
    loadingDetectorMetrics,
    meteringBarchartdata,
    period,
    handleMonthChange,
    selectedMonth,
    handleYearChange,
    selectedYear,
  } = useMeteringInfo();

  const currentYear = dayjs().year();
  const currentMonth = dayjs().month() + 1; // month() returns 0-11
  const filteredMonths = selectedYear === currentYear ? months.filter((month) => month.value <= currentMonth) : months;

  const years = Array.from({ length: currentYear - 2023 + 1 }, (v, k) => 2023 + k);

  return (
    <Stack sx={{ backgroundColor: "white", borderRadius: "10px", padding: "10px 20px", height: "100%", gap: "30px" }}>
      <AccountSectionTitle text="Usage" />

      <Box sx={{ display: "flex", alignItems: "center", gap: "10px", justifyContent: "center" }}>
        <Typography sx={{ fontSize: "18px", lineHeight: "24px" }}>Usage Period:</Typography>
        <Box sx={{ width: "210px", minWidth: "144px" }}>
          <TextFieldInput
            variant="select"
            name="period"
            id="period-select"
            value={period.backend}
            onChange={handleTimePeriodChange}
            options={USAGE_MAPPINGS.map((mapping) => ({
              value: mapping.backend,
              label: mapping.ui,
            }))}
          />
        </Box>
        {period === MONTH_TO_DATE && (
          <Box sx={{ width: "210px" }}>
            <TextFieldInput
              variant="select"
              name="month"
              id="month-select"
              value={selectedMonth as unknown as string}
              onChange={handleMonthChange}
              options={filteredMonths.map((month) => ({
                value: month.value.toString(),
                label: month.label,
              }))}
            />
          </Box>
        )}
        <Box sx={{ width: "210px" }}>
          <TextFieldInput
            variant="select"
            name="year"
            id="year-select"
            value={selectedYear as unknown as string}
            onChange={handleYearChange}
            options={years.map((year) => ({
              value: year.toString(),
              label: year.toString(),
            }))}
          />
        </Box>
      </Box>

      <MeteringBarChart
        data={meteringBarchartdata}
        loadingInfo={loadingAccountMetrics}
        accountMetricsError={accountMetricsError}
      />

      <ActivityByDetectorTable data={detectorsMetrics} loadingInfo={loadingDetectorMetrics} />
    </Stack>
  );
}
